import { cn } from "@/lib/utils";

/*
 * The two square Mazu marks, drawn from the brain's canonical files
 * (whatamidoing/brand/mazu/visor.svg and m-bar.svg). Keep the geometry in step
 * with those files. Brand rules: a layout holds one square mark; the visor is
 * for favicons, app icons, avatars, and the sidebar; the M tile is for
 * documents, footers, and rows of company logos, and never stands beside the
 * word Mazu.
 */

type MarkProps = { className?: string; title?: string };

/** The visor tile: a black bar with two coral eyes on a white tile. */
export function MazuMark({ className, title = "Mazu" }: MarkProps) {
  return (
    <svg viewBox="0 0 32 32" role="img" aria-label={title} data-slot="mazu-mark" className={cn("size-9 shrink-0", className)}>
      <rect width="32" height="32" rx="8" fill="var(--mazu-body)" />
      <rect x="3.2" y="10.2" width="25.6" height="11.6" rx="5.8" fill="var(--mazu-ink)" />
      <circle cx="11.15" cy="16" r="3.15" fill="var(--mazu-coral)" />
      <circle cx="20.85" cy="16" r="3.15" fill="var(--mazu-coral)" />
    </svg>
  );
}

/** The M tile: a black M with a coral block under its left side. */
export function MazuMTile({ className, title = "Mazu" }: MarkProps) {
  return (
    <svg viewBox="0 0 32 32" role="img" aria-label={title} data-slot="mazu-m-tile" className={cn("size-9 shrink-0", className)}>
      <rect width="32" height="32" rx="4" fill="var(--mazu-body)" />
      <path fill="var(--mazu-ink)" d="M7 3h6.51L16.02 12.73 18.51 3H25v16h-4.04V6.8L17.83 19h-3.66L11.05 6.8V19H7V3z" />
      <rect x="7" y="22" width="9" height="6" fill="var(--mazu-coral)" />
    </svg>
  );
}
